import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../api';

export default function Subscribe() {
  const [params] = useSearchParams();
  const priceId = params.get('priceId');
  const navigate = useNavigate();

  useEffect(() => {
    if (!priceId) return navigate('/plans');
    api.post('/subscribe', { priceId })
       .then(res => window.location.href = res.data.url)
       .catch(() => navigate('/plans'));
  }, [priceId, navigate]);

  return (
    <div className="container">
      <h1>Procesando suscripción…</h1>
      <p>Redirigiendo a Stripe Checkout</p>
    </div>
  );
}
